import React from "react";
import Team from "@/components/Team";

export default function TeamPage() {
  return (
    <div className="pt-24" data-testid="page-team">
      <Team />
    </div>
  );
}
